import { ProjectMeta } from '@anm/api/modules/uploads';
import Dialog from '@anm/components/modals/Dialog';
import AlertBlock, { AlertBlockProps } from '@anm/components/notification/AlertBlock';
import { FC } from 'react';

import ProjectList from './ProjectsList';

export type UploadProjectsModalProps = AlertBlockProps & { projects?: ProjectMeta[] };

const UploadProjectsModal: FC<UploadProjectsModalProps> = ({ title, description, projects, onButtonClick }) => (
  <Dialog onModalClose={onButtonClick} noMinWidth onSubmit={onButtonClick}>
    <AlertBlock
      button={{
        text: 'Ok',
        size: 'upper-medium',
        variant: 'blue-saturated'
      }}
      maxWidth={366}
      titleSize="medium"
      {...{ title, description }}
      onButtonClick={onButtonClick}
    >
      <ProjectList {...{ projects }} />
    </AlertBlock>
  </Dialog>
);

export default UploadProjectsModal;
